import React, { ReactElement } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { QrCodeIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';

type Props = {
  title: string;
  icon?: ReactElement;
};

export const SectionTitle = ({ title, icon }: Props): ReactElement => {
  return (
    <Flex gap="5px" align="center" mb="10px">
      {icon || <NovaIcon icon={QrCodeIcon} size="m" color="icon.secondary" />}
      <Text textStyle="body.m.regular" color="text.secondary">
        {title}
      </Text>
    </Flex>
  );
};
